'use strict';
/**
 * Drawer off-canvas: overlay, chiusura con X / click fuori, blocco scroll html/body.
 * Desktop: .drawer--right | .drawer--left sul wrapper .drawer
 * Mobile: bottom sheet (stili in _drawer.scss)
 *
 * Apri:   [data-drawer-open="id-elemento"]
 * Chiudi: [data-drawer-close], click su .drawer__overlay
 */

const SCROLL_LOCK_CLASS = 'is-drawer-open';
const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
const DRAWER_TRANSITION_DURATION = 350;
const STICKY_ELEMENT_SELECTORS = ['#lvz-top-banner', '#lvz-header-info-container', '#lvz-header-template', '[data-lvz-pdp-sticky-bar]', '[data-subscriptions-sticky]'];
const FROZEN_PROPERTIES = ['position', 'top', 'bottom', 'left', 'width', 'margin-top', 'margin-bottom'];
const FROZEN_HEADER_DATA_KEY = 'drawerFrozenHeaderStyles';
const FROZEN_HEADER_PLACEHOLDER_CLASS = 'drawer-frozen-header-placeholder';

function getFocusable($drawer) {
	return $drawer
		.find('.drawer__panel')
		.find(FOCUSABLE)
		.filter(':visible');
}

function lockScroll() {
	$('html').addClass(SCROLL_LOCK_CLASS);
	$('body').addClass('overflow-hidden');
}

function unlockScroll() {
	if (!$('.drawer.is-open').length) {
		$('html').removeClass(SCROLL_LOCK_CLASS);
		$('body').removeClass('overflow-hidden');
		restoreStickyHeaders();
	}
}

function freezeStickyHeaders() {
	STICKY_ELEMENT_SELECTORS.forEach(function freezeHeader(selector) {
		const element = document.querySelector(selector);
		const $element = element ? $(element) : $();
		let styles;
		let rect;

		if (!element) {
			return;
		}

		styles = window.getComputedStyle(element);
		rect = element.getBoundingClientRect();

		if (
			styles.display === 'none' ||
			styles.visibility === 'hidden' ||
			styles.opacity === '0' ||
			rect.height <= 0 ||
			rect.bottom <= 0 ||
			rect.top >= window.innerHeight
		) {
			return;
		}

		if (!$element.data(FROZEN_HEADER_DATA_KEY)) {
			$element.data(FROZEN_HEADER_DATA_KEY, {
				inlineStyles: FROZEN_PROPERTIES.map(function readInlineStyle(property) {
					return {
						property: property,
						value: element.style.getPropertyValue(property),
						priority: element.style.getPropertyPriority(property)
					};
				}),
				placeholder: $('<div>')
					.addClass(FROZEN_HEADER_PLACEHOLDER_CLASS)
					.css({
						height: Math.round(rect.height) + 'px',
						width: '100%',
						marginTop: styles.marginTop,
						marginBottom: styles.marginBottom
					})
					.insertAfter($element)
			});
		}

		element.style.setProperty('position', 'fixed', 'important');
		element.style.setProperty('top', Math.round(rect.top) + 'px', 'important');
		element.style.setProperty('bottom', 'auto', 'important');
		element.style.setProperty('left', Math.round(rect.left) + 'px', 'important');
		element.style.setProperty('width', Math.round(rect.width) + 'px', 'important');
		element.style.setProperty('margin-top', '0', 'important');
		element.style.setProperty('margin-bottom', '0', 'important');
	});
}

function restoreStickyHeaders() {
	STICKY_ELEMENT_SELECTORS.forEach(function restoreHeader(selector) {
		const element = document.querySelector(selector);
		const $element = element ? $(element) : $();
		const originalStyles = $element.data(FROZEN_HEADER_DATA_KEY);

		if (!element || !originalStyles) {
			return;
		}

		originalStyles.inlineStyles.forEach(function restoreInlineStyle(style) {
			element.style.setProperty(style.property, style.value, style.priority);
		});
		if (originalStyles.placeholder && originalStyles.placeholder.remove) {
			originalStyles.placeholder.remove();
		}
		$element.removeData(FROZEN_HEADER_DATA_KEY);
	});
}

function openDrawer($drawer) {
	if (!$drawer.length) return;

	const closeTimeout = $drawer.data('drawerCloseTimeout');
	if (closeTimeout) {
		window.clearTimeout(closeTimeout);
		$drawer.removeData('drawerCloseTimeout');
	}

	$('.drawer.is-open')
		.not($drawer)
		.each(function closeOther() {
			closeDrawer($(this));
		});

	if (!$drawer.data('returnFocus') && document.activeElement) {
		$drawer.data('returnFocus', document.activeElement);
	}

	freezeStickyHeaders();
	$drawer.removeClass('is-closing').addClass('is-open').attr('aria-hidden', 'false');
	lockScroll();

	// Focus management only for drawers that opt in (e.g. the filter modal).
	if ($drawer.is('[data-drawer-trap]')) {
		const $focusable = getFocusable($drawer);
		if ($focusable.length) {
			$focusable.first().trigger('focus');
		}
	}
}

function closeDrawer($drawer) {
	if (!$drawer.length) return;

	if (!$drawer.hasClass('is-open')) {
		return;
	}

	const closeTimeout = $drawer.data('drawerCloseTimeout');
	if (closeTimeout) {
		window.clearTimeout(closeTimeout);
	}

	const returnFocus = $drawer.data('returnFocus');
	const activeElement = document.activeElement;

	if (activeElement && $drawer.has(activeElement).length) {
		if (returnFocus && returnFocus.focus) {
			returnFocus.focus();
		} else if (activeElement.blur) {
			activeElement.blur();
		}
	}

	$drawer.removeClass('is-open').addClass('is-closing').attr('aria-hidden', 'true');
	unlockScroll();

	if (returnFocus && returnFocus.focus) {
		returnFocus.focus();
	}
	$drawer.removeData('returnFocus');

	$drawer.data(
		'drawerCloseTimeout',
		window.setTimeout(function () {
			$drawer.removeClass('is-closing').removeData('drawerCloseTimeout');
		}, DRAWER_TRANSITION_DURATION)
	);
}

function getDrawerFromTrigger($el) {
	const id = $el.data('drawer-open') || $el.attr('data-drawer-open');
	if (!id) return $();
	const el = document.getElementById(String(id));
	return el ? $(el) : $();
}

function initDrawer() {
	$(document).on('click', '[data-drawer-open]', function onDrawerOpenClick(e) {
		e.preventDefault();
		const $drawer = getDrawerFromTrigger($(this));
		openDrawer($drawer);
	});

	$(document).on('click', '[data-drawer-close]', function onDrawerCloseClick(e) {
		e.preventDefault();
		const $fromClose = $(this).closest('.drawer');
		if ($fromClose.length) {
			closeDrawer($fromClose);
			return;
		}
		closeDrawer($('.drawer.is-open'));
	});

	$(document).on('click', '.drawer__overlay', function onDrawerOverlayClick() {
		closeDrawer($(this).closest('.drawer'));
	});

	$(document).on('keydown', function onDrawerKeydown(e) {
		const $open = $('.drawer.is-open').last();
		if (!$open.length) return;

		if (e.key === 'Escape') {
			closeDrawer($open);
			return;
		}

		// Trap Tab focus inside the open drawer (opt-in via data-drawer-trap).
		if (e.key === 'Tab' && $open.is('[data-drawer-trap]')) {
			const $focusable = getFocusable($open);
			if (!$focusable.length) return;
			const first = $focusable.first()[0];
			const last = $focusable.last()[0];
			if (e.shiftKey && document.activeElement === first) {
				e.preventDefault();
				last.focus();
			} else if (!e.shiftKey && document.activeElement === last) {
				e.preventDefault();
				first.focus();
			}
		}
	});
}

$(() => {
	initDrawer();
});

module.exports = initDrawer;
module.exports.openDrawer = openDrawer;
module.exports.closeDrawer = closeDrawer;
module.exports.freezeStickyHeaders = freezeStickyHeaders;
module.exports.restoreStickyHeaders = restoreStickyHeaders;
